import { useMemo } from 'react'

import { OptionsProps } from '@avantstay/backoffice-core'

import { casesFiltersStore } from '@new/domains/operations/screens/CasesV2/stores/CasesFiltersStore'
import { CaseFilterIds } from '@new/domains/operations/screens/CasesV2/utils/config'
import {
  splitTaxonomyFilterValues,
  TaxonomyFilterLevel,
} from '@new/domains/operations/screens/CasesV2/utils/taxonomyFilterOptions'

interface UseTaxonomyColumnFilterProps {
  legacyFilterId: CaseFilterIds
  level: TaxonomyFilterLevel
  legacyValues?: string[]
  taxonomyValues?: string[]
  taxonomyOptions: OptionsProps<string>[]
}

export const useTaxonomyColumnFilter = ({
  legacyFilterId,
  level,
  legacyValues,
  taxonomyValues,
  taxonomyOptions,
}: UseTaxonomyColumnFilterProps) => {
  const initialValue = useMemo(
    () => [...(legacyValues ?? []), ...(taxonomyValues ?? [])],
    [legacyValues, taxonomyValues],
  )

  const handleDataFilter = (values?: string[]) => {
    const taxonomyNodeIds = new Set(taxonomyOptions.map(option => option.value))
    // A parent selection can hide taxonomy values; they must not become legacy filters.
    const applicableValues = values?.filter(
      value => !taxonomyValues?.includes(value) || taxonomyNodeIds.has(value),
    )
    const splitValues = splitTaxonomyFilterValues(applicableValues, taxonomyNodeIds)

    casesFiltersStore.applyColumnTaxonomyFilter({
      legacyFilterId,
      level,
      legacyValues: splitValues.legacyValues,
      taxonomyValues: splitValues.taxonomyValues,
    })
  }

  return { initialValue, handleDataFilter }
}
